// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__34bJ1","actionsCol":"EnrolledClinics_actionsCol__2ov0E"};